export default "__VITE_ASSET__DGE28cAV__"